<template>
  <div class="bottom-nav">
    <div
      v-for="nav in navItems"
      :key="nav.id"
      :class="['nav-item', { active: currentNav === nav.id }]"
      @click="goPage(nav.pagePath)"
    >
      <div class="nav-icon" aria-hidden="true">
        <svg v-if="nav.id === 'home'" viewBox="0 0 24 24">
          <path d="M3.5 10.5 12 3l8.5 7.5v9a1.5 1.5 0 0 1-1.5 1.5h-4.5v-6h-5v6H5a1.5 1.5 0 0 1-1.5-1.5v-9Z" />
        </svg>
        <svg v-else-if="nav.id === 'category'" viewBox="0 0 24 24">
          <rect x="3" y="3" width="7" height="7" rx="2" />
          <rect x="14" y="3" width="7" height="7" rx="2" />
          <rect x="3" y="14" width="7" height="7" rx="2" />
          <rect x="14" y="14" width="7" height="7" rx="2" />
        </svg>
        <svg v-else viewBox="0 0 24 24">
          <circle cx="12" cy="8" r="4" />
          <path d="M4.5 21a7.5 7.5 0 0 1 15 0" />
        </svg>
      </div>
      <div class="nav-text"> {{ $t(`tab.${nav.key}`) }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentNav: {
      type: String,
      default: 'category'
    }
  },
  data() {
    return {
      navItems: [
        { id: 'home', key: 'home', pagePath: '/' },
        { id: 'category', key: 'category', pagePath: '/user/category/category' },
        { id: 'profile', key: 'profile', pagePath: '/user/member/member' }
      ]
    }
  },
  methods: {
    goPage(pagePath) {
      // 如果当前路由已经是目标路径，则不重复跳转
      if (this.$route.path === pagePath) return;
      this.$router.push(pagePath);
    }
  }
};
</script>

<style scoped>
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  max-width: 450px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 7px 32px 9px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  background: rgba(249, 249, 249, 0.88);
  box-shadow: 0 -1px 12px rgba(0, 0, 0, 0.04);
  z-index: 20;
  backdrop-filter: saturate(180%) blur(20px);
  box-sizing: border-box;
}

.nav-item {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  min-width: 64px;
  padding: 2px 8px;
  color: #8e8e93;
  cursor: pointer;
  transition: color 0.18s ease, transform 0.18s ease;
}

.nav-item.active {
  color: #007aff;
}

.nav-item:active {
  transform: scale(0.94);
}

.nav-icon {
  width: 25px;
  height: 25px;
}

.nav-icon svg {
  display: block;
  width: 100%;
  height: 100%;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.nav-item.active .nav-icon svg {
  fill: currentColor;
  stroke-width: 1.5;
}

.nav-text {
  font-size: 10px;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;
}

/* 安全区域适配 */
@supports (padding-bottom: env(safe-area-inset-bottom)) {
  .bottom-nav {
    padding-bottom: calc(7px + env(safe-area-inset-bottom));
  }
}
</style>
